<div class="login-page">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 right-side">
        <achoo-placeholder [placeholderId]="'loginComponentHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="true">
          <router-outlet></router-outlet>
        </achoo-placeholder>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.html